import './index.less';
import React, {useEffect} from 'react';
import {convertPrice, decodeSign} from '@/utils/tools';

function fastVideoTip({docDetail, router, show}) {
  const {video_fee, doctor_sign_extension} = docDetail;

  function onClickOrderVideo() {
    location.href = location.origin + `/order/video?docId=${docDetail.doctor_id}`;
  }

  // if (!show || !video_fee || video_fee === '0' || !decodeSign(doctor_sign_extension, 11)) {
  //   return null;
  // }
  return (
    <div className="fast-video-box" onClick={onClickOrderVideo.bind(this)}>
      <div className="fast-video">
        <div className="txt">
          <div className="txt1">即刻视频看诊</div>
          <div className="txt2">十分钟迅速视频问诊</div>
        </div>
        <div className="price">￥{convertPrice(video_fee, 2)}</div>
        <div className="button">立即看诊</div>
      </div>
    </div>
  );
}

export default fastVideoTip;
